<template>
  <egg-label-list
    title="corporate.healthSolutions"
    titleColor="#603813"
    :starIconObj="{ componentName: 'shared', imgName: 'starIconLightBrown', imgFormat: 'svg' }"
    :starBackgroundObj="{ componentName: 'shared', imgName: 'starGroupIconLightBrownLeft', imgFormat: 'svg' }"
    :eggBackgroundObj="{ componentName: 'shared', imgName: 'lightbrownegg', imgFormat: 'svg' }"
    labelColor="#4E4E4E"
    :eggIconLabelList="corporateStore.eggDescList"
    class="pb-24"
  />
</template>

<script setup lang="ts">
import { useCorporateStore } from "@/stores/corporate";
import { computed, onMounted, ref, toRefs } from "vue";
import { useRouter } from "vue-router";
import { useI18n } from "vue-i18n";

const corporateStore = useCorporateStore();
const router = useRouter();
const { t, locale } = useI18n();

onMounted(async () => {});

//not on home page, stop intro timer
router.beforeEach(async (to, from) => {});

const goTo = (refName) => {};

const routeTo = (position) => {
  router.push({ name: position, params: { uid: "lczmx" } });
};
</script>